export default "https://cdn-static-staging.gokick.com/assets/8be3c2df1b703b0455f7e6e91c436c85253a82ea/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";